export function normalizeMatrixRows(value: unknown): string[][] {
    if (Array.isArray(value)) {
        const rows: string[][] = [];

        for (const row of value) {
            if (!Array.isArray(row)) {
                continue;
            }

            rows.push(row.map(cell => String(cell).trim()));
        }

        return rows.filter(row => row.length > 0);
    }

    if (typeof value !== 'string') {
        return [];
    }

    const text = value.trim();
    if (!text) {
        return [];
    }

    return extractMatrixRows(text)
        .map(row => row.split(',').map(cell => cell.trim()))
        .filter(row => row.length > 0);
}

function extractMatrixRows(matrixText: string): string[] {
    const text = matrixText.trim();
    if (!text.startsWith('[') || !text.endsWith(']')) {
        return [];
    }

    const inner = text.slice(1, -1);
    const rows: string[] = [];
    let depth = 0;
    let rowStart = -1;

    for (let i = 0; i < inner.length; i += 1) {
        const char = inner[i];
        if (char === '[') {
            if (depth === 0) {
                rowStart = i + 1;
            }
            depth += 1;
            continue;
        }

        if (char === ']') {
            depth -= 1;
            if (depth === 0 && rowStart >= 0) {
                rows.push(inner.slice(rowStart, i));
                rowStart = -1;
            }
        }
    }

    return rows;
}

export function stringifyMatrixRows(value: unknown): string {
    if (typeof value === 'string') {
        return value;
    }

    if (!Array.isArray(value)) {
        return '';
    }

    const rows = value.filter((row): row is unknown[] => Array.isArray(row));
    if (rows.length === 0) {
        return '';
    }

    return `[${rows.map(row => `[${row.map(cell => String(cell).trim()).join(',')}]`).join(',')}]`;
}
